import api from './../libs/api';

export default {
  
  getLeads: (params = {}) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/leads`, { params })
        .then(({ status, data }) => {
          console.log(data);
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  getLead: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/leads/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  createLead: (leadData) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/leads`, leadData)
        .then(({ status, data }) => {
          if (status === 201) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  updateLead: (id, leadData) => {
    return new Promise((resolve, reject) => {
      api()
        .put(`/leads/${id}`, leadData)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  deleteLead: (id) => {
    return new Promise((resolve, reject) => {
      api()
        .delete(`/leads/${id}`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  uploadLeadsCsv: (formData) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/leads/upload-csv`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(({ status, data }) => {
          // Handle both 200 (success) and 207 (partial success)
          if (status === 200 || status === 207) {
            resolve(data);
          } else {
            throw new Error(`Failed with status: ${status}`);
          }
        })
        .catch(error => {
          // If error has response data with skipped records, still resolve with that data
          if (error.response && (error.response.status === 207 || error.response.status === 200)) {
            resolve(error.response.data);
          } else {
            reject(error);
          }
        });
    });
  },

  getLeadStats: (timeRange) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/leads/stats`, { params: { timeRange } })
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  getLatestLeads: () => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/leads/latest`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  },

  togglePublicStatus: (leadId) => {
    return new Promise((resolve, reject) => {
      api()
        .post(`/leads/${leadId}/toggle-public`)
        .then(({ status, data }) => {
          if (status === 200) resolve(data);
          throw new Error(`Failed with status: ${status}`);
        })
        .catch(error => reject(error));
    });
  }
};
